import actionCreatorFactory from 'typescript-fsa';

import { IFetchELearningProgressParam } from 'src/scenario/ELearningScenarioFactory';

const actionCreator = actionCreatorFactory();

/** 課題情報設定アクションクリエータ */
export const setExerciseFormParams = actionCreator<{
	reportName: string;
	reportTemplateFileName: string;
	submittedReportFile: string;
	resultStatus: number;
	displayDownloadButton: boolean;
	displayUploadButton: boolean;
	displaySubmittedReportDownloadButton: boolean;
	displayDeleteButton: boolean;
}>('SET_EXERCISE_FORM_PARAMS');

/** 課題情報初期化アクションクリエータ */
export const clearExerciseFormParams = actionCreator<{}>(
	'CLEAR_EXERCISE_FORM_PARAMS'
);

/** 課題ページ初期化 */
export const initExcerciseForm = actionCreator<IFetchELearningProgressParam>(
	'INIT_EXCERCISE＿FORM'
);



// WEBPACK FOOTER //
// ./src/actions/exerciseForm.ts